export default "https://cdn.questicon.mathletics.com/assets/images/modal-cancel-icon-cdff47cc14b20d6f7cd3a17b5afe0263.svg";